export enum EventProgress{
    Upcoming = "Upcoming",
    InProgress = "In Progress",
    Completed = "Completed",
}